(function () {
  const pills = document.querySelectorAll('.bulk-quantity-pill');
  const form = document.querySelector('form[action$="/cart/add"]');

  if (!form || !pills.length) return;

  const quantityInput = form.querySelector('input[name="quantity"]');

  const firstPillValue = pills[0].getAttribute('data-quantity-value');
  pills[0].classList.add('active');
  if (quantityInput) {
    quantityInput.value = firstPillValue;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  pills.forEach((pill) => {
    pill.addEventListener('click', function () {
      const value = this.getAttribute('data-quantity-value');

      // Update the quantity input
      if (quantityInput) {
        quantityInput.value = value;
        // Trigger change event for any listeners
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update active state on pills
      pills.forEach((p) => p.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Sync pills when quantity input changes manually
  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      const currentVal = this.value;
      pills.forEach((pill) => {
        if (pill.getAttribute('data-quantity-value') === currentVal) {
          pill.classList.add('active');
        } else {
          pill.classList.remove('active');
        }
      });
    });
  }
})();

/* swiper.js init for UGC in testimonials.liquid */
document.addEventListener('DOMContentLoaded', () => {
  // Initialize Swiper for UGC
  const ugcSwiper = new Swiper('.ugc-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    loop: true,
    centeredSlides: true,

    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    loopAdditionalSlides: 4,

    /*     breakpoints: {
      480: {
        slidesPerView: 1.2,
        spaceBetween: 16
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup:1,
        spaceBetween: 18
      },
      1024: {
        slidesPerView: 2.66,
        slidesPerGroup:1,
        spaceBetween: 18
      }
    }, */
    // Navigation arrows
    navigation: {
      nextEl: '.ugc-swiper-button-next',
      prevEl: '.ugc-swiper-button-prev',
    },
  });
});

/* swiper.js init for featured ingredients in product_featured-ingredients.liquid */
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 767px)');
  let ingredientsSwiper = null;

  function initIngredientsSwiper() {
    if (mq.matches && !ingredientsSwiper && document.querySelector('.ingredients-swiper')) {
      ingredientsSwiper = new Swiper('.ingredients-swiper', {
        slidesPerView: 1.4,
        spaceBetween: 16,
        grabCursor: true,
        slidesOffsetAfter: 40,
        pagination: {
          el: '.ingredients-swiper .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.ingredients-swiper .swiper-button-next',
          prevEl: '.ingredients-swiper .swiper-button-prev',
        },
      });
    }
  }

  initIngredientsSwiper();
  mq.addEventListener('change', initIngredientsSwiper);
});

/* tabs handler */
function initTabs(root = document) {
  root.querySelectorAll('[data-tabs-menu]').forEach((menu) => {
    const id = menu.dataset.tabsMenu;
    const pane = root.querySelector(`[data-tabs-pane="${id}"]`);
    if (!pane) return;

    const buttons = [...menu.children];
    const panels = [...pane.children];

    function activate(index) {
      buttons.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
      panels.forEach((panel, i) => panel.classList.toggle('is-active', i === index));
      menu.dispatchEvent(new CustomEvent('tabs:change', { bubbles: true, detail: { index } }));
    }

    buttons.forEach((btn, i) => btn.addEventListener('click', () => activate(i)));

    activate(0);
  });
}

initTabs();
